const clients = [
  { name: "Bisleri", src: "/clients/bisleri.png" },
  { name: "CLEAR", src: "/clients/clear.png" },
  { name: "Bailey", src: "/clients/bailey.png" },
  { name: "Royal", src: "/clients/royal.png" },
  { name: "Patanjali", src: "/clients/patanjali.png" },
  { name: "Parle Agro", src: "/clients/parle-agro.png" },
];

export default function ClientStrip() {
  return <div className="client-strip-window" data-testid="client-logo-strip" aria-label="SGN clients"><div className="client-strip-track">{[...clients, ...clients].map((client, index) => <div className="client-logo-card" key={`${client.name}-${index}`}><img src={client.src} alt={`${client.name} client logo`} loading="lazy" /></div>)}</div></div>;
}
